import { Button } from "semantic-ui-react";

export const UpdateSubscriberPreferencesToast = (props: {
  groupName: string;
  handleUndo: () => Promise<void>;
  type: string;
}) => {
  return (
    <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
      <span>
        You have {props.type == "Subscribe" ? "subscribed" : "unsubscribed"} to <strong>{props.groupName}</strong>.
      </span>
      {props.type === "Subscribe" && (
        <Button
          onClick={() => props.handleUndo()} // Wrap the promise in a function
          className='tw-border-none tw-bg-transparent tw-text-[#2185D0]'
        >
          Undo
        </Button>
      )}
    </div>
  );
};
